var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.themeBar)?_c('span',[_c('icon-badge',{attrs:{"iconName":"el-icon-setting","content":"主题配置"},on:{"click":_vm.handleOpenThemeBar}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }